import ky from 'ky';
import { updateHttpError } from 'ducks/meta';

const apiFailureMiddleware = (store) => (next) => (action) => {
  // If not an async action then no need to check for api errors.
  if (typeof action !== 'function') {
    return next(action);
  }
  const result = next(action);
  // Async function returning promise will throw the error.
  if (result instanceof Promise) {
    return result.catch((err) => {
      if (err instanceof ky.HTTPError) {
        const { response } = err;
        store.dispatch(updateHttpError(response.clone()));
      }
      throw err;
    });
  }
  return result;
};

export default apiFailureMiddleware;
